import apiClient from "./axios"

// ✅ Get car care services (with filters / pagination)
export const getCarCareServices = async (params = {}) => {
  const { data } = await apiClient.get("/car-care-services", { params })
  return data
}

// ✅ Get single car care service by ID
export const getCarCareService = async id => {
  const { data } = await apiClient.get(`/car-care-services/${id}`)
  return data
}

// ✅ Get hierarchical tree
export const getCarCareServiceTree = async () => {
  const { data } = await apiClient.get("/car-care-services/tree")
  return data
}

// ✅ Create car care service
export const createCarCareService = async payload => {
  const { data } = await apiClient.post("/car-care-services", payload)
  return data
}

// ✅ Update car care service
export const updateCarCareService = async ({ id, ...payload }) => {
  const { data } = await apiClient.patch(`/car-care-services/${id}`, payload)
  return data
}

// ✅ Soft delete
export const deleteCarCareService = async id => {
  const { data } = await apiClient.delete(`/car-care-services/${id}`)
  return data
}
